import { LightningElement, api, wire } from "lwc";
import { LabelsAdapter } from "common/labelsAdapter";
import { MenuAdapter, MENU_ADAPTER_DEFAULT_VALUE } from "common/menuAdapter";
import {
  OverflowMenuAdapter,
  OVERFLOW_MENU_ADAPTER_DEFAULT_VALUE,
} from "common/overflowMenuAdapter";
import { getNextFocusIndex } from "common/a11y";

var data$9 = { overflow_button: "Mehr" };
data$9.overflow_button;

var data$8 = { overflow_button: "More" };
data$8.overflow_button;

var data$7 = { overflow_button: "Más" };
data$7.overflow_button;

var data$6 = { overflow_button: "Más" };
data$6.overflow_button;

var data$5 = { overflow_button: "Plus" };
data$5.overflow_button;

var data$4 = { overflow_button: "Altro" };
data$4.overflow_button;

var data$3 = { overflow_button: "その他" };
data$3.overflow_button;

var data$2 = { overflow_button: "더 보기" };
data$2.overflow_button;

var data$1 = { overflow_button: "Mais" };
data$1.overflow_button;

var data = { overflow_button: "更多" };
data.overflow_button;

var locales = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  de: data$9,
  en: data$8,
  es: data$7,
  esMX: data$6,
  fr: data$5,
  it: data$4,
  ja: data$3,
  ko: data$2,
  ptBR: data$1,
  zhCN: data,
});

class segmentedControl extends LightningElement {
  items = [];
  focusValue = null;
  _value = null;
  @api get value() {
    return this._value;
  }
  set value(newValue) {
    // Already selected, do nothing
    if (!newValue || this._value === newValue) {
      return;
    }
    this._value = this.focusValue = newValue;

    // Update items with computed properties
    this.items = this.items.map((i) => ({
      ...i,
      active: i.value === newValue,
    }));
  }
  @wire(MenuAdapter, {
    items: "$overflowMenu.overflowItems",
    template: "$template",
  })
  menu = MENU_ADAPTER_DEFAULT_VALUE;
  @wire(OverflowMenuAdapter, {
    items: "$items",
    template: "$template",
    willUpdate: "$overflowMenuWillUpdate",
  })
  overflowMenu = OVERFLOW_MENU_ADAPTER_DEFAULT_VALUE;
  @wire(LabelsAdapter, {
    locales,
  })
  labels = null;
  get visibleItems() {
    return this.overflowMenu.visibleItems.map((i) => ({
      ...i,
      ...this.calculatedItemProperties(i.active),
    }));
  }
  get overflowItems() {
    return this.overflowMenu.overflowItems;
  }
  connectedCallback() {
    this.addEventListener("privateitemregister", this.handleItemRegister);
  }
  renderedCallback() {
    if (!this.value && this.items.length) {
      this.value = this.items[0].value;
    }
  }
  disconnectedCallback() {
    this.removeEventListener("privateitemregister", this.handleItemRegister);
  }
  calculatedItemProperties(isActive) {
    return {
      active: isActive,
      tabindex: isActive ? 0 : -1,
    };
  }
  handleItemRegister = (e) => {
    e.stopPropagation();
    const element = e.detail;
    const isActive = element.value === this.value;
    const item = {
      ...this.calculatedItemProperties(isActive),
      ...element,
      overflow: false,
      onfocus: () => {
        this.focusValue = item.value;
      },
      onmenuselect: () => {
        this.value = item.value;

        // Re-focus the menu button
        this.template.querySelector('[data-menu="trigger"]').focus();
        this.dispatchChange();
      },
      onselect: () => {
        this.value = item.value;
        this.dispatchChange();
      },
    };
    this.items.push(item);
  };
  overflowMenuWillUpdate = () => {
    this.menu.close();
  };
  dispatchChange() {
    this.dispatchEvent(
      new CustomEvent("change", {
        detail: this.value,
      })
    );
  }
  handleKeyDown(e) {
    const element = e.target;
    switch (e.code) {
      // Cycle through tabs
      case "ArrowLeft":
      case "ArrowRight": {
        e.preventDefault();
        e.stopPropagation();
        const direction = e.code === "ArrowLeft" ? "prev" : "next";
        const { visibleItems } = this.overflowMenu;
        const currentFocusedIndex = Math.max(
          0,
          visibleItems.findIndex((i) => i.value === this.focusValue)
        );
        const newIndex = getNextFocusIndex(
          direction,
          currentFocusedIndex,
          visibleItems.length
        );

        // Update focus
        this.template
          .querySelectorAll(".tds-segmented-control__button")
          .item(newIndex)
          .focus();
        break;
      }
      case "Enter":
      case "Space":
        e.preventDefault();
        e.stopPropagation();
        if (!element.getAttribute("data-menu")) {
          this.value = this.focusValue;
        }
        this.dispatchChange();
        break;
    }
  }
}

export default segmentedControl;
